import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

// Config
import threeDSecureMethodState from './ThreeDSecureMethod.state';

// Components
import Container from '@components/container';
import Iframe from '@widgets/iframe';

const ThreeDSecureMethod = () => {
  const hiddenFormRef = useRef<HTMLFormElement>(null);
  const threeDSMethodTimeoutId = useRef<null | ReturnType<typeof setTimeout>>(null);

  const { action = '', id = '', inputData = {} } = useSelector(threeDSecureMethodState);

  const target = '3dsMethodIframe';

  useEffect(() => {
    threeDSMethodTimeoutId.current = setTimeout(() => {
      window.parent.postMessage('johnlewis-3ds-method=not_completed', '*');
    }, 10000);

    setTimeout(() => {
      if (hiddenFormRef.current) {
        hiddenFormRef.current.submit();
      }
    }, 0);

    return () => {
      if (threeDSMethodTimeoutId.current) {
        clearTimeout(threeDSMethodTimeoutId.current);
      }
    };
  }, []);

  return (
    Object.keys(inputData).length > 0 && (
      <Container hidden>
        <form ref={hiddenFormRef} action={action} id={id} method="POST" name={id} target={target}>
          {Object.keys(inputData).map((key) => (
            <input key={key} id={key} name={key} type="hidden" value={inputData[key] || ''} />
          ))}
        </form>
        <Iframe name={target} />
      </Container>
    )
  );
};

export default ThreeDSecureMethod;
